import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area recent-files" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[57] || (_cache[57] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Spam</h3><select class=\"form-select month-select form-control\" aria-label=\"Default select example\"><option selected>Today</option><option value=\"1\">Weekly</option><option value=\"2\">Monthly</option><option value=\"3\">Yearly</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[56] || (_cache[56] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "File Name"),
                _createElementVNode("th", { scope: "col" }, "Owner"),
                _createElementVNode("th", { scope: "col" }, "Listed Date"),
                _createElementVNode("th", { scope: "col" }, "File Type"),
                _createElementVNode("th", { scope: "col" }, "File Size"),
                _createElementVNode("th", { scope: "col" }, "File Items"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, " folder ", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Dashboard Design ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("td", null, "Linda Maddox", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Nov 20, 2024", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, ".pdf", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "1.2 GB", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "69", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, " folder ", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Important Documents ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("td", null, "Juanita Lavigne", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("td", null, "Nov 18, 2024", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("td", null, ".zip", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "2.6 GB", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", null, "236", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, "folder", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Product Design ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("td", null, "Roy Pope", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("td", null, "Nov 17, 2024", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("td", null, ".psd", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("td", null, "3.2 GB", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", null, "365", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, "folder", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Dashboard Design File ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "Cecil Jones", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", null, "Nov 15, 2024", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("td", null, ".fig", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("td", null, "1 GB", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("td", null, "25", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, "folder", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Media Files ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("td", null, "Trudy Venegas", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("td", null, "Nov 14, 2024", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("td", null, ".jpg", -1)),
                _cache[32] || (_cache[32] = _createElementVNode("td", null, "1.5 GB", -1)),
                _cache[33] || (_cache[33] = _createElementVNode("td", null, "153", -1)),
                _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, "folder", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Graphic Design File ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("td", null, "Sharilyn Goodall", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("td", null, "Nov 13, 2024", -1)),
                _cache[38] || (_cache[38] = _createElementVNode("td", null, ".png", -1)),
                _cache[39] || (_cache[39] = _createElementVNode("td", null, "1.6 GB", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("td", null, "142", -1)),
                _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, "folder", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Personal Photo ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("td", null, "Annie Carver", -1)),
                _cache[44] || (_cache[44] = _createElementVNode("td", null, "Nov 09, 2024", -1)),
                _cache[45] || (_cache[45] = _createElementVNode("td", null, ".gif", -1)),
                _cache[46] || (_cache[46] = _createElementVNode("td", null, "1.2 GB", -1)),
                _cache[47] || (_cache[47] = _createElementVNode("td", null, "175", -1)),
                _cache[48] || (_cache[48] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/apps/file-manager/my-drive",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-28 text-warning" }, "folder", -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14 position-relative top-1" }, " Audio File ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[50] || (_cache[50] = _createElementVNode("td", null, "Winona Etzel", -1)),
                _cache[51] || (_cache[51] = _createElementVNode("td", null, "Nov 08, 2024", -1)),
                _cache[52] || (_cache[52] = _createElementVNode("td", null, ".mp3", -1)),
                _cache[53] || (_cache[53] = _createElementVNode("td", null, "1.3 GB", -1)),
                _cache[54] || (_cache[54] = _createElementVNode("td", null, "136", -1)),
                _cache[55] || (_cache[55] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex justify-content-between align-items-center gap-1" }, [
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-warning" }, "grade")
                    ]),
                    _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete")
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Pagination, {
          items: "8",
          total: "30"
        })
      ])
    ])
  ]))
}